import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { TransferenciaInsumos } from '../../../../types/TransferenciaInsumos.type';
import { Page } from '../../../../types/Page.type';

@Injectable({
  providedIn: 'root'
})
export class TransferenciaInsumosService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getTransferencias(
    page: number,
    size: number,
    sortField: string,
    sortDirection: string,
    instancias: string,
    dataInicial: string | null,
    dataFinal: string | null,
    fgStatusInteg?: string[],
    search?: string
  ) {
    let url = `${this.configService.getApiUrlRoot()}/transfinsumos/?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}&page=${page}&size=${size}&sort=${sortField},${sortDirection}`;

    if (fgStatusInteg && fgStatusInteg.length > 0) {
      url += `&fgStatusInteg=${fgStatusInteg.join(',')}`;
    }

    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    return this.httpClient.get<Page<TransferenciaInsumos>>(url)
  }

  exportarTransferenciasSelecionadas(ids: number[]) {
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/transfinsumos/relatorios/exportar`, ids, { responseType: 'blob' })
  }

  exportarTodasTransferencias(instancias: string, dataInicial: string | null, dataFinal: string | null) {
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/transfinsumos/relatorios/exportar-todos?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`, null, { responseType: 'blob' })
  }

  getTentativasHabilitado() {
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/transfinsumos/tentativas-habilitado`)
  }

  reenviarTransferencias(ids: number[]) {
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/transfinsumos/erp/reenviar`, ids)
  }
}
